module.exports = __webpack_public_path__ + "5365a31e275a6eff44e02fcfcf891bde.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/3_D2.mp3
// module id = 119
// module chunks = 0